// CC-CONTACT2 — valeurs du "lien" du contact secondaire.
// Liste UNIQUE et partagée : garantit le même contenu / même ordre sur
// AdminBlock (bloc CLIENT du dossier) ET ClientDetail (page Clients).
// La valeur choisie est stockée telle quelle dans contact_secondaire_relation.
export const CONTACT_RELATION_VALUES = [
  "Conjoint",
  "Enfant",
  "Aidant",
  "Proche",
  "Voisin",
  "Autre",
];

// Format attendu par le composant Field (select) : { value, label }.
export const CONTACT_RELATION_OPTIONS = CONTACT_RELATION_VALUES.map((v) => ({
  value: v,
  label: v,
}));
